import { render, staticRenderFns } from "./Medicals.vue?vue&type=template&id=6eb17d6c&scoped=true"
import script from "./Medicals.vue?vue&type=script&lang=js"
export * from "./Medicals.vue?vue&type=script&lang=js"
import style0 from "./Medicals.vue?vue&type=style&index=0&id=6eb17d6c&prod&scoped=true&lang=css"
import style1 from "./Medicals.vue?vue&type=style&index=1&id=6eb17d6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb17d6c",
  null
  
)

export default component.exports